import { Link } from "react-router-dom";

const Success = () => {
    return (
      <div className="min-h-screen flex items-center justify-center bg-green-50">
        <div className="bg-white rounded-lg shadow-lg p-10 max-w-md text-center">
          <div className="mb-4">
            <svg className="w-16 h-16 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5 2a9 9 0 11-6.219-15.072A9 9 0 0120 12z"></path>
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-2 text-gray-700">Payment Successful!</h2>
          <p className="text-gray-500 mb-4">Thank you for your purchase. Your transaction has been completed successfully.</p>
          <div className="mt-6">
            <Link to="/" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded shadow">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    );
  }
  
  export default Success;
  